import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=3f0924dc&scoped=true&"
import script from "./UserMenu.vue?vue&type=script&lang=ts&"
export * from "./UserMenu.vue?vue&type=script&lang=ts&"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=3f0924dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0924dc",
  null
  
)

export default component.exports